export default "__VITE_ASSET__oNukn8FX__"